// Modules
import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';

// Helpers
import * as NavigationHelper from '@shared/helpers/navigation.helper';

// Store - Reducer
import { AppState } from '@store/reducers';
// Store - Actions
import * as GeneralActions from '@store/actions/general.actions';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  // Constructor
  constructor(private _appStore$: Store<AppState>) {}

  // Public method to set current navigation
  public setCurrentNavigation(route: string): void {
    this._appStore$.dispatch(
      GeneralActions.setCurrentPage({
        payload: NavigationHelper.getCurrentNavigationItem(route),
      })
    );
  }

  // Public method to set current navigation not listed in the menu
  public setCurrentNavigationNotInMenu(route: string): void {
    this._appStore$.dispatch(
      GeneralActions.setCurrentPage({
        payload: NavigationHelper.getNotMenuNavigationItem(route),
      })
    );
  }

  // Public method to clear navigation
  public clearNavigation(): void {
    this._appStore$.dispatch(GeneralActions.setCurrentPage({ payload: null }));
  }
}
